module.exports = __webpack_public_path__ + "static/media/5.4d9584e4.jpg";